module.exports = __webpack_public_path__ + "static/media/savings-investments.12b8b77d.svg";